import { CostCenterData, IssuerData } from "~/application/types/entities/CustomerBI.type";
import { Box } from "~/components/Box";
import { Card } from "~/components/Card";
import { Flex } from "~/components/Flex";
import { Col } from "~/components/Grid";
import { Text } from "~/components/Text";
import { H4 } from "~/components/Typography";
import { asCurrency } from "~/utils/mask.utils";

type IssuerResumeProps = {
  issuerResume?: IssuerData[];
  onSelectMultiValues: IssuerResumeSelectHandler;
  selectedMultiValues: IssuerResumeSelectedValues;
};

type IssuerResumeSelectHandler = ({ value, field }: { value: string; field: "issuers" }) => void;

type IssuerResumeSelectedValues = {
  issuers: string[];
};

export function IssuerResume({
  issuerResume,
  onSelectMultiValues,
  selectedMultiValues,
}: IssuerResumeProps) {
  return (
    <>
      <Card css={{ height: "600px" }}>
        <Flex css={{ p: "$5" }}>
          <H4>Valor por solicitante</H4>
        </Flex>
        <Box css={{ overflow: "auto" }}>
          {issuerResume?.map((issuer) => (
            <>
              <Flex
                justify="between"
                key={`isser-resume-${issuer.uuid}`}
                onClick={() => onSelectMultiValues({ value: issuer.uuid, field: "issuers" })}
                css={{
                  p: "$4",
                  borderRadius: "$2",
                  backgroundColor: selectedMultiValues.issuers?.includes(issuer.uuid)
                    ? "$primary-light"
                    : "transparent",
                  alignItems: "center",
                  borderBottom: "1px solid $neutrals-lightest",
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "$neutrals-lightest",
                  },
                }}
              >
                <Flex align="center" gap="4">
                  <Flex gap="1" direction="column" justify="center">
                    <Text fw="600">{issuer.name}</Text>
                    <Text css={{ fontSize: "$sm", color: "$neutrals-darkest" }}>
                      Último pedido: {issuer.lastOrderDate}
                    </Text>
                  </Flex>
                </Flex>
                <Text fw="700" css={{ color: "$success-base" }}>
                  {asCurrency(issuer.value)}
                </Text>
              </Flex>
            </>
          ))}
        </Box>
      </Card>
    </>
  );
}
